import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { carouselStyle, dotStyle, dotsWrapperStyle } from './helpers/styles';
const TrialModalCarousel = _ref => {
  let {
    children
  } = _ref;
  const [active, setActive] = useState(0);
  return /*#__PURE__*/React.createElement(_StyledDiv, null, children[active], /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css: dotsWrapperStyle(children.length)
  }, children.map((_, index) => {
    return /*#__PURE__*/React.createElement(_StyledDiv3, {
      "data-testid": `TrialModalCarouselDot${index}`,
      key: `carousel-dot-${index}`,
      onClick: () => {
        setActive(index);
      },
      $_css2: dotStyle(active === index)
    });
  })));
};
TrialModalCarousel.displayName = 'TrialModalCarousel';
TrialModalCarousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};
export default TrialModalCarousel;
var _StyledDiv = _styled("div")`${carouselStyle}`;
var _StyledDiv2 = _styled2("div")`${p => p.$_css}`;
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "component___StyledDiv3",
  componentId: "sc-vfi1cd-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=component.js.map